import {
  PERSON_RECEIVE,
  PERSON_ERROR,
  PERSON_CHANGE_MODE,
  ViewMode,
  SET_PERSON_ERRORS,
  SET_PERSONS_SUCCESS_MESSAGE,
} from '../constants';
import { error as errorReducer } from './Error.reducer';

const defaultState = {
  list: [],
  mode: ViewMode.List,
  roles: [],
  errors: {},
  personSuccessMessage: undefined,
};

export const person = (state = defaultState, action) => {
  const { type, payload } = action;
  switch (type) {
    case PERSON_RECEIVE:
    case PERSON_CHANGE_MODE:
      return {
        ...state,
        errors: {},
        ...payload,
      };
    case PERSON_ERROR:
      return {
        ...state,
        errors: errorReducer(state.errors, action),
      };
    case SET_PERSON_ERRORS:
      return {
        ...state,
        errors: payload.errors || {},
      };
    case SET_PERSONS_SUCCESS_MESSAGE:
      return {
        ...state,
        personSuccessMessage: payload.personSuccessMessage,
      };
    default:
      return state;
  }
};
